<!--
 * @Date: 2020-05-14 16:01:22
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-14 16:05:29
 * @FilePath: /xy-pc/src/components/Empty.vue
 -->
<template>
  <div class="emptyBox">
    <img src="../assets/image/empty.png" alt />
    <span>
      <strong>很抱歉，</strong>
      {{moreTxt}}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    moreTxt: {
      default: "没有找到相关课程",
    },
  },
};
</script>

<style scoped lang="less">
.emptyBox {
  height: 400px;
  width: 100%;
  text-align: center;
  
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
}
</style>